import { PsnsRedriveApiFactory } from "../../../lusca-search-api/LuscaSearchApiFactory";
import { Stage } from "../../../lusca-search-api/generated-src";

export interface UploadResult {
  s3Uri: string;
  etag?: string;
}

interface StartPsnsRedriveParams {
  stage: Stage;
  eventsS3Uri: string;
  eventsS3Etag: string;
  dryRun: boolean;
  mcmId?: string;
}

export const useExecutePsnsRedrive = () => {
  // Upload once and reuse the object for the dry run, the MCM and the real run:
  // a re-upload changes the ETag the MCM pins.
  const uploadFile = async (
    file: File,
    stage: Stage
  ): Promise<UploadResult> => {
    const psnsRedriveApi = PsnsRedriveApiFactory();

    const uploadUrlResponse = await psnsRedriveApi.getPsnsRedriveUploadUrl(
      stage,
      file.name
    );

    if (!uploadUrlResponse.data?.uploadUrl || !uploadUrlResponse.data?.s3Uri) {
      throw new Error("Failed to get upload URL");
    }

    // Must match the ContentType the backend signed into the URL.
    const uploadResponse = await fetch(uploadUrlResponse.data.uploadUrl, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": "application/x-ndjson",
      },
    });

    if (!uploadResponse.ok) {
      throw new Error("Failed to upload file to S3");
    }

    const etagHeader = uploadResponse.headers.get("ETag");
    const etag = etagHeader?.replace(/"/g, "");

    return {
      s3Uri: uploadUrlResponse.data.s3Uri,
      etag,
    };
  };

  const startRedrive = async ({
    stage,
    eventsS3Uri,
    eventsS3Etag,
    dryRun,
    mcmId,
  }: StartPsnsRedriveParams) => {
    const psnsRedriveApi = PsnsRedriveApiFactory();

    const response = await psnsRedriveApi.startPsnsRedrive(stage, {
      eventsS3Uri,
      eventsS3Etag,
      dryRun,
      mcmId,
    });

    return response.data;
  };

  return { uploadFile, startRedrive };
};
